import React, { createContext, useContext, useState, useEffect } from 'react';
import { axios } from '../axios';
import { LangContext } from '../App';

const SeoContext = createContext(null);

export const SeoProvider = ({ children }) => {
    const lang = useContext(LangContext);
    const [seoData, setSeoData] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchSeoData = async () => {
            setLoading(true);
            try {
                const response = await axios.get(`${lang}/seo`);
                setSeoData(response.data);
            } catch (error) {
                console.error('Error fetching SEO data:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchSeoData();
    }, [lang]);

    return (
        <SeoContext.Provider value={{ seoData, loading }}>
            {children}
        </SeoContext.Provider>
    );
};

export const useSeo = () => {
    const context = useContext(SeoContext);
    if (!context) {
        throw new Error('useSeo must be used within a SeoProvider');
    }
    return context;
};
